import { ApiProperty } from "@nestjs/swagger";

export class UnitsDataDto {
    @ApiProperty()
    unitId: number;

    @ApiProperty()
    unitName: string;

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    versionFlag: number;
}